import { defineStore } from 'pinia'

interface LayoutState {
    sidebarOpen: boolean
    isNavigating: boolean
    /** Disables the global pull-to-refresh (e.g. on the matrix overscroll view). */
    pullToRefreshDisabled: boolean
}

export const useLayoutStore = defineStore('layout', {
    state: (): LayoutState => ({
        sidebarOpen: false,
        isNavigating: false,
        pullToRefreshDisabled: false,
    }),
    actions: {
        toggleSidebar() {
            this.sidebarOpen = !this.sidebarOpen
        },
        openSidebar() {
            this.sidebarOpen = true
        },
        closeSidebar() {
            this.sidebarOpen = false
        },
        startNavigation() {
            this.isNavigating = true
        },
        endNavigation() {
            this.isNavigating = false
        },
    },
})
